import {
  Action,
  Dispatch,
  ThunkAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  addOrders as addOrdersApi,
  updateOrders as updateOrdersApi,
  deleteOrders as deleteOrdersApi,
  getSellers as getSellersApi,
  addSellers as addSellersApi,
  updateSellers as updateSellersApi,
  deleteSellers as deleteSellersApi,
  getProductList as getProductListApi,
  addProductList as addProductListApi,
  updateProductList as updateProductListApi,
  deleteProductList as deleteProductListApi,
  getProductGrid as getProductGridApi,
  addProductGrid as addProductGridApi,
  updateProductGrid as updateProductGridApi,
  deleteProductGrid as deleteProductGridApi,
  getReview as getReviewApi,
  addReview as addReviewApi,
  updateReview as updateReviewApi,
  deleteReview as deleteReviewApi,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getDiamonds as getDiamondsApi,
  addDiamonds as addDiamondsApi,
  getAllInventories as getAllInventoriesApi,
  updateInventory as updateInventoryApi,
  deleteInventory as deleteInventoryApi,
  getDiamond as getDiamondApi,
  getDiamondByStockId as getDiamondByStockIdApi,
  getOrders as getOrdersApi,
  addOrder as addOrderApi,
  updateOrder as updateOrderApi,
  deleteOrder as deleteOrderApi,
  addShape as addShapeApi,
  getShapes as getShapesApi,
  updateShape as updateShapeApi,
  deleteShape as deleteShapeApi,
  addDiamondPrices as addDiamondPricesApi,
  getDiamondPrices as getDiamondPricesApi,
  countDiamondPrices as countDiamondPricesApi,
  getCenterDiamondPrices as getCenterDiamondPricesApi,
} from "helpers/backend_helper";
import { addDiamondsBody } from "pages/Diamond/Products/AddDiamonds";
import { updateInventoryPayloadType } from "pages/Diamond/Inventory/AllInventories";
import {
  addShapeError,
  addShapeSuccess,
  deleteShapeError,
  deleteShapeSuccess,
  getCenterDiamondPricesError,
  getCenterDiamondPricesSuccess,
  getShapesError,
  getShapesSuccess,
  handleError,
  setDiamondPrices,
  setIsLoading,
  updateShapeError,
  updateShapeSuccess,
} from "./reducer";
import { RootState } from "slices";

// Inventory

export const getAllInventories = createAsyncThunk(
  "diamond/getAllInventories",
  async () => {
    try {
      const response: any = await getAllInventoriesApi();
      return response.result;
    } catch (error) {
      return error;
    }
  }
);
export const updateInventory = createAsyncThunk(
  "diamond/updateInventory",
  async (body: updateInventoryPayloadType) => {
    try {
      const response: any = await updateInventoryApi(body);
      toast.success("Inventory updated Successfully", { autoClose: 2000 });
      return response.result;
    } catch (error) {
      toast.error("Inventory updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteInventory = createAsyncThunk(
  "diamond/deleteInventory",
  async (id: string) => {
    try {
      await deleteInventoryApi(id);
      toast.success("Inventory deleted Successfully", { autoClose: 2000 });
      return id;
    } catch (error) {
      toast.error("Inventory deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

// Orders
export const addOrder = createAsyncThunk(
  "diamond/addOrders",
  async (body: any) => {
    try {
      const response = addOrderApi(body);
      const data = await response;
      toast.success("Order Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Order Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getOrders = createAsyncThunk(
  "diamond/getOrders",
  async (type: string) => {
    try {
      const response: any = await getOrdersApi(type);
      return response.result;
    } catch (error) {
      return error;
    }
  }
);

export const updateOrder = createAsyncThunk(
  "diamond/updateOrder",
  async (body: any) => {
    try {
      const response: any = await updateOrderApi(body);
      toast.success("Order updated Successfully", { autoClose: 2000 });
      return response.result;
    } catch (error) {
      toast.error("Order updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "diamond/deleteOrders",
  async (id: string) => {
    try {
      await deleteOrderApi(id);
      toast.success("Order deleted Successfully", { autoClose: 2000 });
      return id;
    } catch (error) {
      toast.error("Order deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const updateOrders = createAsyncThunk(
  "ecommerce/updateOrders",
  async (event: any) => {
    try {
      const response = updateOrdersApi(event);
      const data = await response;
      toast.success("Order updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Order updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteOrders = createAsyncThunk(
  "ecommerce/deleteOrders",
  async (event: any) => {
    try {
      const response = deleteOrdersApi(event);
      toast.success("Order deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Order deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getSellers = createAsyncThunk("ecommerce/getSellers", async () => {
  try {
    const response = getSellersApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addSellers = createAsyncThunk(
  "ecommerce/addSellers",
  async (event: any) => {
    try {
      const response = addSellersApi(event);
      const data = await response;
      toast.success("Seller Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Seller Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const updateSellers = createAsyncThunk(
  "ecommerce/updateSellers",
  async (event: any) => {
    try {
      const response = updateSellersApi(event);
      const data = await response;
      toast.success("Seller updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Seller updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteSellers = createAsyncThunk(
  "ecommerce/deleteSellers",
  async (event: any) => {
    try {
      const response = deleteSellersApi(event);
      toast.success("Seller deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Seller deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getProductList = createAsyncThunk(
  "ecommerce/getProductList",
  async () => {
    try {
      const response = getProductListApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Diamonds

export const getDiamonds = createAsyncThunk(
  "diamond/getDiamonds",
  async (body: any) => {
    try {
      const response: any = await getDiamondsApi(body);
      return response.result;
    } catch (error) {
      return error;
    }
  }
);
export const getDiamond = createAsyncThunk(
  "diamond/getDiamond",
  async (id: string) => {
    try {
      const response: any = await getDiamondApi(id);
      return response.result;
    } catch (error) {
      return error;
    }
  }
);
export const getDiamondByStockId = createAsyncThunk(
  "diamond/getDiamondByStockId",
  async (stockId: string) => {
    try {
      const response: any = await getDiamondByStockIdApi(stockId);
      return [response.result];
    } catch (error) {
      return error;
    }
  }
);

export const addDiamonds = createAsyncThunk(
  "diamond/addDiamonds",
  async (body: addDiamondsBody) => {
    try {
      // call add Diamond APi Here
      const response = await addDiamondsApi(body);
      toast.success("Diamonds added Successfully!", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.success("Diamonds addition failed!", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteDiamond = createAsyncThunk(
  "diamond/deleteDiamonds",
  async (id: string) => {
    try {
      // call delete Diamond APi Here
      return id;
    } catch (error) {
      return error;
    }
  }
);

export const addProductList = createAsyncThunk(
  "ecommerce/addProductList",
  async (event: any) => {
    try {
      const response = addProductListApi(event);
      const data = await response;
      toast.success("Data Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Data Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const updateProductList = createAsyncThunk(
  "ecommerce/updateProductList",
  async (event: any) => {
    try {
      const response = updateProductListApi(event);
      const data = await response;
      toast.success("Data updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Data updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const deleteProductList = createAsyncThunk(
  "ecommerce/deleteProductList",
  async (event: any) => {
    try {
      const response = deleteProductListApi(event);
      toast.success("Data deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Data deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getProductGrid = createAsyncThunk(
  "ecommerce/getProductGrid",
  async () => {
    try {
      const response = getProductGridApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);
export const addProductGrid = createAsyncThunk(
  "ecommerce/addProductGrid",
  async (event: any) => {
    try {
      const response = addProductGridApi(event);
      const data = await response;
      toast.success("Data Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Data Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const updateProductGrid = createAsyncThunk(
  "ecommerce/updateProductGrid",
  async (event: any) => {
    try {
      const response = updateProductGridApi(event);
      const data = await response;
      toast.success("Data updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Data updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const deleteProductGrid = createAsyncThunk(
  "ecommerce/deleteProductGrid",
  async (event: any) => {
    try {
      const response = deleteProductGridApi(event);
      toast.success("Data deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Data deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getReview = createAsyncThunk("ecommerce/getReview", async () => {
  try {
    const response = getReviewApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addReview = createAsyncThunk(
  "ecommerce/addReview",
  async (event: any) => {
    try {
      const response = addReviewApi(event);
      const data = await response;
      toast.success("Data Added Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Data Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const updateReview = createAsyncThunk(
  "ecommerce/updateReview",
  async (event: any) => {
    try {
      const response = updateReviewApi(event);
      const data = await response;
      toast.success("Data updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Data updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);
export const deleteReview = createAsyncThunk(
  "ecommerce/deleteReview",
  async (event: any) => {
    try {
      const response = deleteReviewApi(event);
      toast.success("Data deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Data deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const addShape = (body: any) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response: any = await addShapeApi(body);
    toast.success("Shape added Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(addShapeSuccess(response.result));
  } catch (error: any) {
    toast.error("Shape added Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(addShapeError(error));
  }
};

export const getShapes =
  (): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getShapesApi();
      dispatch(setIsLoading(false));
      dispatch(getShapesSuccess(response.result));
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getShapesError(error));
    }
  };

export const updateShape = (body: any) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response: any = await updateShapeApi(body);
    toast.success("Shape updated Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(updateShapeSuccess(response.result));
  } catch (error: any) {
    toast.error("Shape updated Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(updateShapeError(error));
  }
};

export const deleteShape = (id: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await deleteShapeApi(id);
    toast.success("Style deleted Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteShapeSuccess(id as any));
  } catch (error: any) {
    toast.error("Style deleted Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(deleteShapeError(error));
  }
};

export const addDiamondPrices = (body: any) => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response: any = await addDiamondPricesApi(body);
    toast.success("Diamond Prices added Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(setDiamondPrices(response.result));
  } catch (error: any) {
    toast.error("Diamond Prices added Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(handleError(error));
  }
};
export const getDiamondPrices = () => async (dispatch: Dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response: any = await getDiamondPricesApi();
    // toast.success("Diamond Prices added Successfully!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(setDiamondPrices(response.result));
  } catch (error: any) {
    // toast.error("Diamond Prices added Failed!", { autoClose: 2000 });
    dispatch(setIsLoading(false));
    dispatch(handleError(error));
  }
};

export const countDiamondPrices = (body: any) => async (dispatch: Dispatch) => {
  try {
    console.log(body);
    
    dispatch(setIsLoading(true));
    const response: any = await countDiamondPricesApi(body);
    // toast.success("Discount added Successfully!", {
    //   autoClose: 2000,
    // });
    // dispatch(setIsLoading(false));
    // dispatch(countDiamondPrice(response.result));
    
    return response.result;
  } catch (error: any) {
    // toast.error("Discount added Failed!", { autoClose: 2000 });
    // dispatch(setIsLoading(false));
    // dispatch(addDiscountError(error));
  } finally {
    dispatch(setIsLoading(false)); // End loading
  }
};

export const getCenterDiamondPrices =
  (carats: number[]): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setIsLoading(true));
      const response: any = await getCenterDiamondPricesApi(carats);
      dispatch(setIsLoading(false));
      dispatch(getCenterDiamondPricesSuccess(response.result));
      return response.result;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(getCenterDiamondPricesError(error));
    }
  };


